import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_f358njub53: FaireBrandEntity = {
  token: "b_f358njub53",
  type: "brand",
  name: "Comeback",
  avatarUrl:
    "https://cdn.faire.com/fastly/afd0d25d8e4fbd1e016c382bb89c39f2c4f490805a4740614739a935374dbca5.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/31356ecd99b21129065c79287cf994c1b00f0a95c5af7549008a95fb5822b770.png",
  logoUrl:
    "https://cdn.faire.com/fastly/afd0d25d8e4fbd1e016c382bb89c39f2c4f490805a4740614739a935374dbca5.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/31356ecd99b21129065c79287cf994c1b00f0a95c5af7549008a95fb5822b770.png",
  location: "MEMPHIS, TN, USA",
  minimumOrderDollars: 50,
  rating: 4.8,
  reviewCount: 22,
  isTopShop: true,
  isInsider: true,
  description:
    "We started as shop owners and baristas.\nAfter a few years of being in the coffee industry in various roles, we opened up our shop, Comeback Coffee in Memphis, TN. Our goal was to create a unique and welcoming space in the city that raised us. When the pandemic hit, we had to pivot like so many other small businesses. The one request we received was that we somehow provided our coffee sodas during this time.\n\nAfter a lot of thought and RnD, a small team of us (Amy and Hayes McPherson our Co-owners and Ethan McGaughy our now COO) put in the work to can, by hand, small batches of our Field Day for our community. After MANY late nights and continuously selling out, we knew we had to pivot yet again.\n\nWe moved our operations to a garage behind Comeback Coffee and began producing in larger batches of our now two mainstay flavors, Field Day and Southern Style. While far from glamorous, this new space allowed us to scale our operations and begin to send our Coffee Sodas around Memphis.\n\nWe stayed there for a year and a half before we began construction on our pride and joy, Comeback HQ. Comeback HQ is our manufacturing facility, offices, and roastery just two buildings down from where it all started. We now sell nationwide and have an incredibly talented team doing what we love, creating fun beverages and roasting tasty coffees for our community. We're excited to continue to grow that community every day.",
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:03:42.614Z",
    importedBy: "entity-db-cli",
  },
};
